import React, { Fragment } from "react";
import { Alert, Image, Tab, Table, Tabs } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import StudentAttendanceData from "./user/StudentAttendanceData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle, faPhone, faUser } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import $ from "jquery";

const StudentsAttendanceList = (props) => {
    const { t } = useTranslation();
    const { studentsList, setStudentsList, blockForm, classSlots, classData, reloadData, setChangedForm } = props;

    const tabs = [
        {
            eventKey: "signUpList",
            sList: studentsList.signUpList,
            onChangeS: (v, i) => {
                const list = [...studentsList.signUpList];
                list.forEach((e, j) => {
                    if (j === i) e.ua_status_code = v;
                });
                setStudentsList({ ...studentsList, signUpList: list });
            },
        },
        {
            eventKey: "waitingList",
            sList: studentsList.waitingList,
            onChangeS: (v, i) => {
                const list = [...studentsList.waitingList];
                list.forEach((e, j) => {
                    if (j === i) e.ua_status_code = v;
                });
                setStudentsList({ ...studentsList, waitingList: list });
            },
        },
        {
            eventKey: "reservationsList",
            sList: studentsList.reservationsList,
            onChangeS: (v, i) => {
                const list = [...studentsList.reservationsList];
                list.forEach((e, j) => {
                    if (j === i) e.ua_status_code = v;
                });
                setStudentsList({ ...studentsList, reservationsList: list });
            },
        },
    ];

    return (
        <Fragment>
            <Tabs defaultActiveKey="signUpList" id="studentListTab">
                {tabs.map((tab, k) => (
                    <Tab
                        key={k}
                        eventKey={tab.eventKey}
                        title={
                            <>
                                {t(`classes.attendanceList.${tab.eventKey}`)} {tab.eventKey === "signUpList" ? `(${tab.sList.length}/${classSlots})` : `(${tab.sList.length})`}
                            </>
                        }
                    >
                        {tab.sList.length === 0 ? (
                            <p className="fs-5 opacity-75 text-center my-3">{t("classes.noStudentsOnList")}</p>
                        ) : (
                            <Fragment>
                                <Table className="white-table">
                                    <tbody>
                                        {tab.eventKey !== "reservationsList"
                                            ? tab.sList.map((e, i) => (
                                                  <Fragment key={i}>
                                                      <StudentAttendanceData
                                                          student={e}
                                                          i={i}
                                                          onChangeStatus={(v) => {
                                                              tab.onChangeS(v, i);
                                                              $(`#${tab.eventKey}${i}`).removeClass("is-invalid");
                                                              setChangedForm(true);
                                                          }}
                                                          blockForm={blockForm}
                                                          classData={classData}
                                                          reloadData={reloadData}
                                                          tabKey={tab.eventKey}
                                                          setChangedForm={setChangedForm}
                                                      />
                                                  </Fragment>
                                              ))
                                            : tab.sList.map((e, i) => (
                                                  <Fragment key={i}>
                                                      <tr>
                                                          <td rowSpan={2} className="align-top text-center" style={{ wordBreak: "keep-all" }}>
                                                              {i + 1}.
                                                          </td>
                                                          <td className="px-0 border-bottom-0 pb-0" style={{ width: "35px" }}>
                                                              {e.user_avatar_name ? (
                                                                  <Image
                                                                      src={`${process.env.REACT_APP_API_URL}/uploads/usersAvatars/${e.user_avatar_name}`}
                                                                      alt={`${e.user_name} ${e.user_surname} avatar`}
                                                                      className="avatar"
                                                                  />
                                                              ) : (
                                                                  <div className="no-avatar mx-auto">
                                                                      <FontAwesomeIcon icon={faUser} />
                                                                  </div>
                                                              )}
                                                          </td>
                                                          <td className="border-bottom-0 pb-0">
                                                              {e.user_name}
                                                              <br />
                                                              {e.user_surname}
                                                          </td>
                                                          <td className="border-bottom-0 pb-0">
                                                              <FontAwesomeIcon icon={faPhone} className="me-2" />
                                                              {e.user_phone}
                                                          </td>
                                                      </tr>
                                                      <tr>
                                                          <td colSpan={2}>
                                                              {t("reservations.reservationCreateDate")}: {moment(e.ur_create_date).format("YYYY-MM-DD HH:mm:ss")}
                                                          </td>
                                                          <td>
                                                              {t("reservations.reservationEndDate")}: {moment(e.ur_end_date).format("YYYY-MM-DD HH:mm:ss")}
                                                          </td>
                                                      </tr>
                                                  </Fragment>
                                              ))}
                                    </tbody>
                                </Table>
                                {tab.eventKey === "reservationsList" && (
                                    <Alert className="my-3 alert-small" variant="info">
                                        <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                                        {t("info.madeReservations")}
                                    </Alert>
                                )}
                            </Fragment>
                        )}
                    </Tab>
                ))}
            </Tabs>
        </Fragment>
    );
};

export default StudentsAttendanceList;
